import TopNav from "./components/TopNav";
import Hero from "./components/Hero";
import TopicWall from "./components/TopicWall";
import HeadlineFeed from "./components/HeadlineFeed";
import BackerModule from "./components/BackerModule";
import RelationModule from "./components/RelationModule";
import ChatModule from "./components/ChatModule";
import ArchiveModule from "./components/ArchiveModule";
import CommentModule from "./components/CommentModule";
import CtaPanel from "./components/CtaPanel";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <TopNav />
      <main>
        {/* 上疏：版头 + 多卡并列首屏 */}
        <Hero />

        {/* 内容单元：标签 / 话题墙 */}
        <TopicWall />

        {/* 密度开始加大：头条深挖 */}
        <HeadlineFeed />

        {/* 背后金主 · 资本穿透 */}
        <BackerModule />

        {/* 隐藏关系网 */}
        <RelationModule />

        {/* 私下聊天 */}
        <ChatModule />

        {/* 未公开信息 · 深挖档案 */}
        <ArchiveModule />

        {/* 互动 / 评论氛围 */}
        <CommentModule />

        {/* 收尾：协作号召 + 页脚 */}
        <CtaPanel />
      </main>
      <Footer />
    </div>
  );
}